import cn from 'classnames';
import { ReactComponent as Green } from '@assets/svg/green-hexagon.svg';
import { ReactComponent as Yellow } from '@assets/svg/yellow-hexagon.svg';
import { ReactComponent as Grey } from '@assets/svg/grey-hexagon.svg';
import { ReactComponent as Lyla } from '@assets/svg/lyla-hexagon.svg';
import { ReactComponent as StarIcon } from '@assets/svg/star.svg';
import styles from './achievement.module.scss';

const hexagon: { [key: string]: JSX.Element } = {
  green: <Green />,
  yellow: <Yellow />,
  grey: <Grey />,
  lyla: <Lyla />,
};

export type TAchievementType = 'green' | 'lyla' | 'yellow' | 'grey';

export function AchievementBar({ type, percentage }: { type: TAchievementType; percentage: number }): JSX.Element {
  return (
    <div
      className={cn(styles.bar, {
        [styles.bar_green]: type === 'green',
        [styles.bar_yellow]: type === 'yellow',
        [styles.bar_lyla]: type === 'lyla',
        [styles.bar_grey]: type === 'grey',
      })}
    >
      <div className={styles.thumb} style={{ width: `${percentage}%` }} />
    </div>
  );
}

export default function Achievement({
  title,
  description,
  goal,
  progress,
  type,
  simplify,
}: {
  title: string;
  description: string;
  goal: number;
  progress: number;
  type: TAchievementType;
  simplify: boolean;
}) {
  return (
    <div
      className={cn(styles.achievement, {
        [styles.green]: type === 'green',
        [styles.yellow]: type === 'yellow',
        [styles.lyla]: type === 'lyla',
        [styles.grey]: type === 'grey',
      })}
    >
      <figure>{hexagon[type]}</figure>
      <div className={styles.info}>
        <h6>{title}</h6>
        <div
          className={cn(styles.description, {
            [styles.desc_simple]: simplify,
            [styles.desc_normal]: !simplify,
          })}
        >
          <p>{description}</p>
          {!simplify && (
            <span
              className={cn({
                [styles.text_green]: type === 'green',
                [styles.text_yellow]: type === 'yellow',
                [styles.text_lyla]: type === 'lyla',
                [styles.text_grey]: type === 'grey',
              })}
            >
              {progress}/{goal}
            </span>
          )}
          {simplify && <p className={styles.current}>Current: {progress}</p>}
        </div>
        {!simplify && <AchievementBar type={type} percentage={(progress / goal) * 100} />}
      </div>
      {!simplify && (
        <button type='button' className={styles.star}>
          <StarIcon />
        </button>
      )}
    </div>
  );
}
